import { createContext, useContext } from "react";
import { AppRoute } from "./routes";

interface RouteContextType {
  primaryRoutes: AppRoute[];
  secondaryRoutes: AppRoute[];
}

export const RouteContext = createContext<RouteContextType>({
  primaryRoutes: [],
  secondaryRoutes: [],
});

export const useRoutes = () => useContext(RouteContext);
